import SegmentGroupComponent from './SegmentGroup'
import { SegmentGroup } from './types'

interface SegmentGroupsListProps {
  groups: SegmentGroup[]
}

const SegmentGroupsList = ({ groups }: SegmentGroupsListProps) => {
  const groupItems = groups.map((group, groupIndex) => (
    <SegmentGroupComponent
      key={group.id || `group-${groupIndex}`}
      group={group}
      groupIndex={groupIndex}
      depth={0}
    />
  ))

  return <>{groupItems}</>
}

export default SegmentGroupsList
